import { Component, OnInit } from '@angular/core';
import { PoPageDefault, PoBreadcrumb, PoBreadcrumbItem } from '@po-ui/ng-components';

@Component({
  selector: 'app-reembolso-despesas-list',
  templateUrl: './reembolso-despesas-list.component.html',
  styleUrls: ['./reembolso-despesas-list.component.css']
})
export class ReembolsoDespesasListComponent implements OnInit {

  public page: PoPageDefault = {
    title: 'Reembolsos Despesas',
    breadcrumb: <PoBreadcrumb>{
      items: <PoBreadcrumbItem[]>[
        { label: 'Home' },
        { label: 'Reembolsos Despesas' },
      ]
    },
    actions: []
  }

  constructor() { }

  ngOnInit(): void {
  }

}
